import * as React from "react";

import { WrapLgMarginBottom } from "App/global-style";
import { Select } from "Components/Form/Select";
import { TextLanguage } from "Store/texts/interfaces";
import { getError } from "Utils/productUtils";
import { FormikProps } from "formik";
import { CaravanTexts } from "../interface";
import { Coverages } from "./Coverages";
import { CaravanProductPriceFormValues } from "./interfaces";
import { getMovableOptions } from "./utils";

interface Props {
  readonly formProps: FormikProps<CaravanProductPriceFormValues>;
  readonly texts: CaravanTexts["formText"]["checkPrice"];
  readonly lang: TextLanguage;
  readonly updatePrices: (payload: CaravanProductPriceFormValues) => void;
}

export const FormElements = (props: Props): React.ReactElement => {
  const { formProps, updatePrices, texts, lang } = props;

  return (
    <>
      <WrapLgMarginBottom>
        <Select
          id="movables"
          name="movables"
          label={texts.movables.label[lang]}
          hint={texts.movables.hint?.[lang]}
          options={getMovableOptions(texts.movables.options, lang)}
          error={getError("movables", formProps)}
          onBlur={() => updatePrices(formProps.values)}
          large
        />
      </WrapLgMarginBottom>

      <Coverages formProps={formProps} />
    </>
  );
};
